module.exports = "<!-- <div *ngIf=\"_load\" class=\"w-100 h-100\">\n\n  <div align=\"center\" class=\"load-screen\">\n    <i class=\"fas fa-spinner fa-4x fa-spin\"> </i>\n    <br>\n    <p class=\"s-m\"> Cargando... </p>\n  </div>\n\n</div> -->\n\n<!-- <ngx-spinner bdOpacity=0 .9 bdColor=\"rgba(84,73,73,0.34)\" size=\"large\" color=\"rgba(44,65,4,0.15)\" type=\"ball-clip-rotate\"\n  fullScreen=\"true\">\n  <p style=\"color: white\"> Loading... </p>\n</ngx-spinner> -->"


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/shared/loader/loader.component.html
// module id = ../../../../../src/app/shared/loader/loader.component.html
// module chunks = main